import { render, staticRenderFns } from "./MallEventModal.vue?vue&type=template&id=2b5e47c9&scoped=true&"
import script from "./MallEventModal.vue?vue&type=script&lang=js&"
export * from "./MallEventModal.vue?vue&type=script&lang=js&"
import style0 from "./MallEventModal.vue?vue&type=style&index=0&id=2b5e47c9&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e47c9",
  null
  
)

export default component.exports